import { render, staticRenderFns } from "./AscSideNavigation.vue?vue&type=template&id=5fadddae&"
import script from "./AscSideNavigation.vue?vue&type=script&lang=js&"
export * from "./AscSideNavigation.vue?vue&type=script&lang=js&"
import style0 from "./AscSideNavigation.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports